<template>
  <div class="planned-transaction-layout-compact-block">
    <div class="planned-transaction-layout-compact">
      <AccountIcon :icon="transaction.template.account.icon"
                   :class="{'opacity-50':applyOpacity}"/>
      <div class="planned-transaction-layout-compact__body">
        <div class="planned-transaction-layout-compact__line">
          <AccountName :name="transaction.template.account.title"
                       :class="{'opacity-50':applyOpacity}"
                       class="min-w-0 flex-1"/>
          <div class="planned-transaction-layout-compact__amount">
            <Value :sum="transaction.template.sum"
                   :currency="transaction.template.account.currency"
                   :isExpense="transaction.template.type === 2 || transaction.template.type === 4"
                   :class="{'line-through':transaction.off_budget,'opacity-50':applyOpacity}"
                   :type="type"/>
            <div v-if="!currentUserIsWatcher" class="planned-transaction-layout-compact__actions">
              <PlannedActions @confirm="$emit('confirm')"
                              @edit="$emit('edit')"/>
            </div>
          </div>
        </div>
        <div v-if="showMeta" class="planned-transaction-layout-compact__meta">
          <Category v-if="transactionCategory"
                    :category="transactionCategory"
                    :class="{'opacity-50':applyOpacity}"/>
          <Comment v-if="transaction.template.comment"
                   :transaction="transaction.template"
                   :comment="transaction.template.comment"
                   :class="{'opacity-50':applyOpacity}"
                   class="min-w-0"/>
        </div>
        <div v-if="showExtra" class="planned-transaction-layout-compact__extra">
          <Contractor v-if="!!transaction.template.contractor && displayContractor"
                      :contractor="transaction.template.contractor"
                      :class="{'opacity-50':applyOpacity}"/>
          <Tags v-if="!!transaction.template.tags.length"
                :tags="transaction.template.tags"
                :type="type"
                class="flex-wrap min-w-0 flex-1"
                :class="{'opacity-50':applyOpacity}"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountIcon from "@/components/common/Transaction/TransactionItem/AccountIcon";
import AccountName from "@/components/common/Transaction/TransactionItem/AccountName";
import Category from "@/components/common/Transaction/TransactionItem/Category";
import Comment from "@/components/common/Transaction/TransactionItem/Comment";
import Contractor from "@/components/common/Transaction/TransactionItem/Contractor";
import Tags from "@/components/common/Transaction/TransactionItem/Tags";
import Value from "@/components/common/Transaction/TransactionItem/Value";
import Actions from "@/components/common/Transaction/TransactionItem/Actions";
import StatusPending from "@/components/common/Transaction/TransactionItem/StatusPending";
import {mapGetters} from "vuex";
import PlannedActions from "@/components/common/PlannedTransaction/PlannedTransactionItem/PlannedActions";

export default {
  name: "PlannedTransactionViewCompact",
  components: {
    PlannedActions,
    StatusPending, AccountName, AccountIcon, Category, Comment, Contractor, Tags, Value, Actions
  },
  props: {
    transaction: {
      type: Object,
      required: true
    },
    applyOpacity: {
      type: Boolean,
      default: false
    },
    displayContractor: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    type() {
      return this.transaction.template.type === 1 ? 'income' : 'expense'
    },
    transactionCategory() {
      if (this.transaction.template.type === 1) {
        return this.transaction.template.income;
      } else {
        return this.transaction.template.expense;
      }
    },
    showMeta() {
      return !!this.transactionCategory || !!this.transaction.template.comment;
    },
    showExtra() {
      return (!!this.transaction.template.contractor && this.displayContractor)
        || !!this.transaction.template.tags.length;
    }
  }
}
</script>

<style scoped lang="scss">
.planned-transaction-layout-compact-block {
  @apply relative py-4 -mx-2 pl-2;
  margin-bottom: -1px;

  &:not(:last-of-type):after {
    @apply bg-border rounded w-full left-0 absolute rounded;
    content: '';
    height: 1px;
    bottom: 1px;
  }
}

.planned-transaction-layout-compact {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 0.9rem;
  align-items: start;

  > :first-child {
    margin-right: 0;
  }
}

.planned-transaction-layout-compact__body {
  min-width: 0;
}

.planned-transaction-layout-compact__line {
  display: flex;
  align-items: center;
  min-width: 0;
}

.planned-transaction-layout-compact__amount {
  display: flex;
  align-items: center;
  flex: none;
  margin-left: 1.2rem;
  white-space: nowrap;
}

.planned-transaction-layout-compact__actions {
  width: 0;
  opacity: 0;
  overflow: hidden;
  flex: none;
  transition: width .2s, opacity .2s;
}

.planned-transaction-layout-compact-block:hover .planned-transaction-layout-compact__actions {
  width: calc(2rem + 30px);
  opacity: 1;
}

.planned-transaction-layout-compact__meta {
  display: flex;
  align-items: center;
  min-width: 0;
  margin-top: 0.3rem;

  > :first-child {
    flex: 0 0 auto;
    min-width: 0;
    max-width: 100%;
  }

  > :first-child:not(:last-child) {
    max-width: 70%;
  }

  > :last-child:not(:first-child) {
    flex: 1 1 auto;
    min-width: 0;
  }
}

.planned-transaction-layout-compact__extra {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  margin-top: 0.4rem;
  margin-left: -0.5rem;
}
</style>